import styled from "react-emotion";
import { Droppable } from "react-beautiful-dnd";
import RowItem from "./RowItem";
import Tooltip from "@material-ui/core/Tooltip";
import HelpTwoToneIcon from "@material-ui/icons/HelpTwoTone";
import { makeStyles } from "@material-ui/core/styles";

const Container = styled("div")`
  margin: 8px;
  border: 1px solid black;
  border-radius: 2px;
`;
const Title = styled("h3")`
  padding: 8px;
  text-align: center;
  display: inline-block;
`;
const RowList = styled("div")`
  padding: 8px;
  overflow-y: scroll;
  height: 370px;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 5px;
  transition: background-color 0.2s ease;
  background-color: ${(props) =>
    props.isDraggingOver ? "rgba(224, 224, 224, 1)" : "white"};
`;

const dragAndDropText = `Drag and drop items to rearrange them in any order you like.`;

const useStyles = makeStyles((theme) => ({
  customWidth: {
    maxWidth: 300,
    fontSize: "14px",
  },
}));

function Column({ column, rowItems, isGallery }) {
  const { id, title } = column;
  const classes = useStyles();

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Title>{title}</Title>
        <Tooltip
          title={dragAndDropText}
          classes={{ tooltip: classes.customWidth }}
        >
          <HelpTwoToneIcon color="primary" fontSize="small" />
        </Tooltip>
      </div>

      <Droppable droppableId={id}>
        {(provided, snapshot) => {
          return (
            <RowList
              innerRef={provided.innerRef}
              {...provided.droppableProps}
              isDraggingOver={snapshot.isDraggingOver}
            >
              {rowItems.map((rowItem, index) => {
                return (
                  <RowItem
                    index={index}
                    key={rowItem.id}
                    rowItem={rowItem}
                    isGallery={isGallery}
                  />
                );
              })}
              {provided.placeholder}
            </RowList>
          );
        }}
      </Droppable>
    </div>
  );
}

export default Column;
